// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1VtMV","notes":"Notes_notes__3nrDs"};